
import React from 'react'
import './Spinner.css'
const Spinner = () => {
  return (
    <>
    <div className='loader'></div>
    <div class="loader1"></div>
    </>
    
  )
}

export default Spinner